import React, {useState, useEffect} from 'react'

import classes from './Slides.module.css'
import PopupsManager from 'react-sdk/PopupsManager';

import Texts from 'react-sdk/Texts';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa6';

import AppState, { POPUPS } from '@/js/AppState';

import S, { Slide } from '@/js/Slides';

import Media from '../Media/Media';
import Popup from '@/components/shared/Popup/Popup';
import Button from '@/components/shared/Button/Button';
import clsx from 'clsx';

/**
 * @param {Object} props
 * @param {Slide} props.page
 * @param {boolean} props.isLast
 */
const Page = ({page, isLast}) => {

  useEffect(() => {
    // TODO vérif un peu plus poussée ??
    if(page.Character) AppState.playSingleDial(page)
  }, [page]);

  function handleNext() {
    PopupsManager.close(POPUPS.SLIDES)
  }

  let onlymedia = !page.Text

  return (
    <div className={classes.page}>
      <div>
        <h3 className={classes.surtitle} dangerouslySetInnerHTML={{__html: page.surtitle}} ></h3>
        <h1 className={classes.title} dangerouslySetInnerHTML={{__html: page.title}} ></h1>
      </div>

      <div className={clsx(classes.page_content, onlymedia && classes.onlymedia)}>
        {page.image &&
        <div className={classes.page_left}>
          <div className={classes.media}>
            <Media path={page.image} />
          </div>
          {page.caption &&
          <div className={classes.caption} dangerouslySetInnerHTML={{__html: page.caption}} />}
        </div>}
        {page.Text &&
        <div className={classes.page_right}>
          <div className={classes.text} dangerouslySetInnerHTML={{__html: page.Text}} />
          {/* <div className={classes.text} dangerouslySetInnerHTML={{__html: page.Text}} />
          <div className={classes.text} dangerouslySetInnerHTML={{__html: page.Text}} />
          <div className={classes.text} dangerouslySetInnerHTML={{__html: page.Text}} /> */}
        </div>}
      </div>

      {isLast &&
      <div className={classes.nextBtnCtnr}>
        {!AppState.waiting &&
        <Button onClick={handleNext}>
          {Texts.get("ftue-popup-next-btn")}
        </Button>}
      </div>}

      {!isLast && <div />}
    </div>
  )
}



const Slides = () => {

  const [currentPage, setCurrentPage] = useState(0);

  let id = PopupsManager.getData(POPUPS.SLIDES)
  let data = S.get(id)


  if(!data) return null

  return (

    <Popup className={classes.Slides}>
      <div className={classes.Slides_content}>
        <Page page={data[currentPage]} isLast={currentPage === data.length - 1} />

        {currentPage > 0 &&
        <Button
        className={classes.prevBtn}
        icon={<FaChevronLeft />}
        onClick={() => setCurrentPage(p => p-1)}
        />}

        {currentPage < data.length - 1 &&
        <Button
        className={classes.nextBtn}
        icon={<FaChevronRight />}
        onClick={() => setCurrentPage(p => p+1)}
        />}

      </div>
    </Popup>
  );
};

export default Slides;
